/******************************************************************************\
 * :$
 *
 * Copyright(c) 2022 SAS Institute Inc., Cary, NC, USA. All Rights Reserved.
 *
 * Name: Teams
 *
 * Purpose:
 *
 * Author: craig (Craig.Simpson@sas.com)
 *
 * Support: SAS(r) Solutions OnDemand
 *
 * Input:
 *
 * Output:
 *
 * Parameters: (if applicable)
 *
 * Dependencies/Assumptions:
 *
 * Usage:
 *
 * History:
 * ddmmmyyyy userid description (Change Code)
 * 20Sep2022 craig File created.
 \******************************************************************************/
import React, {Fragment, useMemo, useState} from "react";
import {Col, Row, Container, Button} from "react-bootstrap";
import {TeamUsersTable} from "../../../components/TeamUsersTable";
import {ITeam} from "../../../models/application/IApplication";
import {useRequest} from "../../../helper/useRequest";

export const Teams: React.FC = () => {
    const [teams, setTeams] = useState<ITeam[]>([]);

    const teamsURL = process.env.REACT_APP_API_URL + "/api/admin/teams";
    const [requestState, getTeamsData] = useRequest({url: teamsURL, initialIsLoading: true,})
    const {isLoading, data, error} = requestState;

    useMemo(() => {
        getTeamsData();
    }, [])

    useMemo(() => {
        if (data != null) {
            setTeams(data);
        }
    },[data])

    const buildTeamData = () => {
        return (
            <Container className="form-container" fluid>
                <Row>
                    <Col className="page-title">
                        <h1>Admin - Teams</h1>
                    </Col>
                </Row>
                <Row>
                    <Col className={"section-header"}>
                        <h3>Gold Standard Teams</h3>
                    </Col>
                </Row>
                <Row className={"section-data-header"}>
                    <Col>Name</Col>
                    <Col>Application</Col>
                    <Col>Start Date</Col>
                    <Col>End Date</Col>
                    <Col></Col>
                </Row>
                {teams?.map((team: ITeam) => (
                    <Container>
                        <Row id={team.TeamID.toString()}>
                            <Col>{team.TeamName}</Col>
                            <Col>{team.TeamSubmissionLinkage?.map(v => <Row>{v.Submission.Organization}</Row>)}</Col>
                            <Col>{new Date(team.StartDate).toLocaleDateString('en-us', {weekday:"long", year:"numeric", month:"short", day:"numeric"})}</Col>
                            <Col>{new Date(team.EndDate).toLocaleDateString('en-us', {weekday:"long", year:"numeric", month:"short", day:"numeric"})}</Col>
                            <Col><Button href={"/admin/team/" + team.TeamID}
                                         variant={"link"}>{'Edit'}</Button></Col>
                        </Row>
                        {TeamUsersTable(team.TeamUserLinkage, false)}
                    </Container>
                ))}
                <Row>
                    <Col>
                        <Button variant="primary" className="btn-submit" type="button" href={"/admin/team"}>
                            Add Team
                        </Button>
                    </Col>
                </Row>
            </Container>
        )
    }

    return (
        <Fragment>
            {isLoading && <p>Loading ...</p>}
            {error && <p>Error</p>}
            {data && buildTeamData()}
        </Fragment>
    );


}